<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <transition name="fade" mode="out-in">
                    <section class="padding-vertical-content lightgray-content" key="pago" id="pago">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                                    <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                                    <PagoPaycometComponent
                                        ref="pago"
                                        tipo_venta="sga"
                                        :jet_id="jet_id"
                                        :session_id="session_id"
                                        :store="$store"
                                        :get-vuex-alias="config.getVuexAlias"
                                    />		
                                </div>
                            </div>
                        </div>
                    </section>
                </transition>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent';

    export default {
        props: {
            jet_id: {
                type: String,
                required: true
            },
            session_id: {
                type: String,
                required: true
            }
        },
        components: {
            PagoPaycometComponent
        }
    }
</script>